import $ from "jquery";
import moment from "moment";
import Context from "../context/context";
import Translation from "../translation/translation";

class Comm {
    static LastSessionCheck = null;

    //static ServerUrl = "http://217.145.94.130:82/";
    // static ServerUrl = "http://217.145.94.130:82/";
    // 192.168.0.20

    // static ServerUrl = "https://server.bultex.eu:1443/";

    // static apiport = 82; //"89";//82

    // static ShowSplash(){
    //     var b = $("body");
    //     if (!b.hasClass("loading")) {
    //         b.addClass("loading");
    //     }
    // }

    // static HideSplash(){
    //     var b = $("body");
    //     if (b.hasClass("loading")) {
    //         b.removeClass("loading");
    //     }
    // }

    static ApiURL() {
        if (window.location.hostname.indexOf("192.168") > -1) {
            return window.CONFIG ? window.CONFIG.API_LOCAL : process.env.REACT_APP_API_LOCAL;
        } else {
            return window.CONFIG ? window.CONFIG.API : process.env.REACT_APP_API;
        }

        // // if (window.location.hostname.indexOf("192.168") > -1)
        // //     return "http://192.168.0.250:82/";
        // // else
        // // 	return "http://192.168.0.250:82/";
        // //иван
        // return "https://www.server.bultex.eu/";

        // return Comm.ServerUrl;
        // return window.location.protocol + "//" + window.location.hostname + ":" + Comm.apiport + "/";
    }

    static ProcessResponse(errcode) {
        alert("ERROR " + errcode);
    }
    static Login(username, password) {
        const userLocale =
            navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language;
        var data = {
            username: username,
            password: password,
            decseparator: Intl.NumberFormat(userLocale)
                .formatToParts(1.1)
                .find((part) => part.type === "decimal").value,
        };

        var result = null;
        // console.log(Comm.ApiURL() + "admin/login");
        $.ajax({
            // url: Comm.ServerUrl + "admin/login",
            url: Comm.ApiURL() + "admin/login",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                if (res != "")
                    result = {
                        Sid: res,
                        //Rights:Comm.GetMyRights(res),
                        Username: username,
                    };
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static SessionUser(sid) {
        var data = {
            session: sid,
        };

        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "admin/sessionuser",
            url: Comm.ApiURL() + "admin/sessionuser",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static Groups(sid) {
        var data = {
            session: sid,
        };

        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "admin/groups",
            url: Comm.ApiURL() + "admin/groups",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.groups;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static User(sid, uid) {
        var data = {
            session: sid,
            uid: uid,
        };

        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "admin/user",
            url: Comm.ApiURL() + "admin/user",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.groups;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static ChangePassword(data) {
        // var result = null; // not used
        $.ajax({
            // url: Comm.ServerUrl + "admin/setuser",
            url: Comm.ApiURL() + "admin/change_password",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });
    }

    static SetUser(data) {
        var result = null;
        $.ajax({
            // url: Comm.ServerUrl + "admin/setuser",
            url: Comm.ApiURL() + "admin/setuser",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.user_id;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static Permissions(sid) {
        return [
            "rusers",
            "eusers",
            "rgroups",
            "egroups",
            "rmanualresort",
            "emanualresort",
            "rarticles",
            "earticles",
            "roperators",
            "eoperators",
            "rsorters",
            "esorters",
            "rinout",
            "einout",
            "rarticlesorters",
            "earticlesorters",
            "roperatorsorters",
            "eoperatorsorters",
            "reditquantity",
            "eeditquantity",
            "rarticlegrouping",
            "earticlegrouping",
            "rwarehousequery",
            "reditdeliveries",
            "reditsales",
            "rsalesreport",
            "rdeliveriesreport",
            "rcompanydata",
            "ecompanydata",
            "raccounts",
            "eaccounts",
            "rbarcodes",
            "ebarcodes",
            "rsales",
            "esales",
            "rdeliveries",
            "edeliveries",
            "rontheway",
            "eontheway",
            "rcontragents",
            "econtragents",
            "rinvoices",
            "einvoices",
            "rcorrections",
            "rshopadministration",
            "rtax",
            "qshopdetail",
            "qshopbrief",
            "qshoppricereport",
            "ruser2sorters",
            "rposterminal",
            "rbarcodesreport",
            "rrecapperiodreport"
        ];
    }

    static SaveGroup(sid, groupdata) {
        var result = null;
        var data = {
            session: sid,
            data: JSON.stringify(groupdata),
        };
        $.ajax({
            // url: Comm.ServerUrl + "admin/savegroup",
            url: Comm.ApiURL() + "admin/savegroup",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.id;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static Users(sid) {
        var data = {
            session: sid,
        };

        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "admin/users",
            url: Comm.ApiURL() + "admin/users",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.users;
                    console.log(json.users);
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        if (result !== null && !result.hasOwnProperty("errcode")) {
            for (var iter = 0; iter < result.length; iter++) {
                var u = result[iter];

                u.groupids = [];
                for (var iter2 = 0; iter2 < u.groups.length; iter2++) {
                    var g = u.groups[iter2];

                    if (g !== null) u.groupids.push(g.id);
                }
            }

            return result;
        }
    }

    static SaveUser(sid, userdata) {
        var result = null;
        var data = {
            session: sid,
            data: JSON.stringify(userdata),
        };
        $.ajax({
            // url: Comm.ServerUrl + "admin/saveuser",
            url: Comm.ApiURL() + "admin/saveuser",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.id;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static ArticleGroups(sid) {
        var data = {
            session: sid,
        };

        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "article/groups",
            url: Comm.ApiURL() + "article/groups",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.hasOwnProperty("code") && json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.groups || [];
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static Articles(sid, visible_only = false) {
        var data = {
            session: sid,
            visible_only: visible_only,
        };

        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "article/articles",
            url: Comm.ApiURL() + "article/articles",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.hasOwnProperty("code") && json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.articles;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static Partners(sid) {
        var data = {
            session: sid,
        };

        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "invoices/partners",
            url: Comm.ApiURL() + "invoices/partners",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.hasOwnProperty("code") && json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.partners;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static SaveArticleGroup(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "article/savegroup",
            url: Comm.ApiURL() + "article/savegroup",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.id;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static DeleteArticleGroup(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "article/delgroup",
            url: Comm.ApiURL() + "article/delgroup",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = null;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static DeletePackingList(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "article/delgroup",
            url: Comm.ApiURL() + "invoices/delete_packing_list",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = null;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static ReportPercent(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "report/percents",
            url: Comm.ApiURL() + "report/percents",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static GetSorters(data) {
        //        Comm.ShowSplash();
        var result = null;
        console.log("URL BASE", Comm.ApiURL() + "scales/sorters");
        $.ajax({
            // url: Comm.ServerUrl + "scales/sorters",
            url: Comm.ApiURL() + "scales/sorters",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.sorters || [];
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });
        //      Comm.HideSplash();
        return result;
    }

    static GetRoots(data) {
        var result = null;

        $.ajax({
            //url: Comm.ServerUrl + "article/roots",
            url: Comm.ApiURL() + "article/roots",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.articles || [];
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static GetRootsWithLevel2(data) {
        var result = null;
        console.log("level2 старт", data);

        $.ajax({
            //url: Comm.ServerUrl + "article/roots",
            url: Comm.ApiURL() + "article/roots_with_level2",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                console.log("level2", res);
                var json = JSON.parse(res);

                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.articles || [];
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log("level2 err", textStatus);
                Comm.ProcessResponse(3);
            });
        console.log("level2 енд");
        return result;
    }

    static SaveArticle(data) {
        var result = null;
        $.ajax({
            // url: Comm.ServerUrl + "article/savearticle",
            url: Comm.ApiURL() + "article/savearticle",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.id;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
            });

        return result;
    }

    static GetInOut(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "article/inout",
            url: Comm.ApiURL() + "article/inout",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = [];
                    for (var i of json.articles) {
                        var obj = { name: i.name, id: i.id };
                        result.push(obj);
                        for (var o of i.out) obj["o" + o.id] = 1;
                    }
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static SaveInOut(data) {
        var result = null;
        $.ajax({
            // url: Comm.ServerUrl + "article/saveinout",
            url: Comm.ApiURL() + "article/saveinout",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.id;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
            });

        return result;
    }

    static GetArticleSorters(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "article/articlesorters",
            url: Comm.ApiURL() + "article/articlesorters",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = [];
                    for (var i of json.articles) {
                        var obj = { name: i.name, id: i.id };
                        result.push(obj);
                        for (var o of i.sorters) obj["o" + o.id] = 1;
                    }
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static SaveArticleSorters(data) {
        var result = null;
        $.ajax({
            // url: Comm.ServerUrl + "article/savearticlesorters",
            url: Comm.ApiURL() + "article/savearticlesorters",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.id;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
            });

        return result;
    }

    static Operators(sid) {
        var data = {
            session: sid,
            visible_only: false,
        };

        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "scales/operators",
            url: Comm.ApiURL() + "scales/operators",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.hasOwnProperty("code") && json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.operators;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static SaveOperator(data) {
        var result = null;
        $.ajax({
            // url: Comm.ServerUrl + "scales/save_operator",
            url: Comm.ApiURL() + "scales/save_operator",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.id;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
            });

        return result;
    }

    static GetOperatorSorters(data) {
        var result = null;

        $.ajax({
            //url: Comm.ServerUrl + "scales/operator_sorters",
            url: Comm.ApiURL() + "scales/operator_sorters",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.sorters;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static SaveOperatorSorters(data) {
        var result = null;
        $.ajax({
            // url: Comm.ServerUrl + "scales/save_operator_sorters",
            url: Comm.ApiURL() + "scales/save_operator_sorters",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.id;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
            });

        return result;
    }

    // static User(sid, uid) { // repeating
    //     var data = {
    //         session: sid,
    //         uid: uid,
    //     };

    //     var result = null;

    //     $.ajax({
    //         // url: Comm.ServerUrl + "admin/user",
    //         url: Comm.ApiURL() + "admin/user",
    //         method: "GET",
    //         cache: false,
    //         data: data,
    //         async: false,
    //     })
    //         .done(function (res) {
    //             var json = JSON.parse(res);
    //             if (json.code != "0") {
    //                 Context.LastErrorCode = json.code;
    //                 Context.ErrJson = json;
    //             } else {
    //                 result = json.groups;
    //             }
    //         })
    //         .fail(function (jqXHR, textStatus) {
    //             console.log(jqXHR.statusText);
    //             Comm.ProcessResponse(3);
    //         });

    //     return result;
    // }

    static CompanyDataLocal(data) {
        var result = null;
        $.ajax({
            // url: Comm.ServerUrl + "invoices/company_data",
            url: Comm.ApiURL() + "invoices/company_data_local",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = {};
                    console.log(json);
                    for (var data of json.data) {
                        switch (data.id) {
                            case 1:
                                result.name = data.data;
                                break;
                            case 2:
                                result.address = data.data;
                                break;
                            case 3:
                                result.loading = data.data;
                                break;
                            case 4:
                                result.mol = data.data;
                                break;
                            case 5:
                                result.vat = data.data;
                                break;
                            case 6:
                                result.eori = data.data;
                                break;
                            default:
                                break;
                        }
                    }
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static CompanyData(data) {
        var result = null;
        $.ajax({
            // url: Comm.ServerUrl + "invoices/company_data",
            url: Comm.ApiURL() + "invoices/company_data",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = {};
                    for (var data of json.data) {
                        switch (data.id) {
                            case 1:
                                result.name = data.data;
                                break;
                            case 2:
                                result.address = data.data;
                                break;
                            case 3:
                                result.loading = data.data;
                                break;
                            case 4:
                                result.mol = data.data;
                                break;
                            case 5:
                                result.vat = data.data;
                                break;
                            case 6:
                                result.eori = data.data;
                                break;
                            default:
                                break;
                        }
                    }
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static SaveCompanyData(data) {
        var result = null;
        $.ajax({
            // url: Comm.ServerUrl + "invoices/save_company_data",
            url: Comm.ApiURL() + "invoices/save_company_data",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.id;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
            });

        return result;
    }

    static Sorters(sid) {
        var data = {
            session: sid,
            visible_only: false,
        };

        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "scales/sorters",
            url: Comm.ApiURL() + "scales/sorters",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.hasOwnProperty("code") && json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.sorters;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static SaveSorter(data) {
        var result = null;
        $.ajax({
            // url: Comm.ServerUrl + "scales/save_sorter",
            url: Comm.ApiURL() + "scales/save_sorter",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.id;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
            });

        return result;
    }

    static Accounts(sid) {
        var data = {
            session: sid,
            visible_only: true,
        };

        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "invoices/accounts",
            url: Comm.ApiURL() + "invoices/accounts",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.hasOwnProperty("code") && json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                    console.log("err", Context);
                } else {
                    result = json.accounts;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static SaveAccount(data) {
        var result = null;
        $.ajax({
            // url: Comm.ServerUrl + "invoices/save_account",
            url: Comm.ApiURL() + "invoices/save_account",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.id;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
            });

        return result;
    }

    static Printing(sid) {
        var data = {
            session: sid,
        };

        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "barcode/printing",
            url: Comm.ApiURL() + "barcode/printing",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.hasOwnProperty("code") && json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.printing;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static SavePrinted(data) {
        var result = null;
        $.ajax({
            // url: Comm.ServerUrl + "barcode/save_printed",
            url: Comm.ApiURL() + "barcode/save_printed",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.id;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
            });

        return result;
    }

    static SaveArticleQuantity(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "scales/set_article_qty",
            url: Comm.ApiURL() + "scales/set_article_qty",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static SavePartner(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "invoices/save_partners",
            url: Comm.ApiURL() + "invoices/save_partners",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.partners[0];
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static ArticleNames(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "article/names",
            url: Comm.ApiURL() + "article/names",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.hasOwnProperty("code") && json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.names;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static SaveArticleName(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "article/save_name",
            url: Comm.ApiURL() + "article/save_name",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.id;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static Receivers(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "invoices/consignee_details",
            url: Comm.ApiURL() + "invoices/consignee_details",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.hasOwnProperty("code") && json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.details;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static SaveReceiver(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "invoices/save_consignee_details",
            url: Comm.ApiURL() + "invoices/save_consignee_details",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.id;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static GetManualSortingData(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "scales/manual_sorting_data",
            url: Comm.ApiURL() + "scales/manual_sorting_data",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.hasOwnProperty("code") && json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.operators;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static SaveManualSort(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "scales/manual_sort",
            url: Comm.ApiURL() + "scales/manual_sort",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.id;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static GetArticleTree(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "article/tree",
            url: Comm.ApiURL() + "article/tree",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.hasOwnProperty("code") && json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.tree;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static SaveSale(data) {
        var result = null;
        var dta = JSON.stringify(data);

        console.log("DATA:", dta);

        $.ajax({
            // url: Comm.ServerUrl + "invoices/save_packing_list",
            url: Comm.ApiURL() + "invoices/save_packing_list",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.id;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
            });

        return result;
    }

    static PackingLists(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "invoices/packing_lists",
            url: Comm.ApiURL() + "invoices/packing_lists",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static PackingListsByPartnersAndGoods(data) {
        var result = null;
        console.log(JSON.stringify(data));
        $.ajax({
            // url: Comm.ServerUrl + "invoices/packing_lists_by_partners_and_goods",
            url: Comm.ApiURL() + "invoices/packing_lists_by_partners_and_goods",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);

                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR);
                console.log(textStatus);

                Comm.ProcessResponse(3);
            });

        return result;
    }

    static DeliveriesPartnersAndGoods(data) {
        console.log("HERE!!!!!!!!!!!!!!!!!");
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "invoices/deliveries_partners_and_goods",
            url: Comm.ApiURL() + "invoices/deliveries_partners_and_goods",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static SalesPartnersAndGoods(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "invoices/partners_and_goods",
            url: Comm.ApiURL() + "invoices/partners_and_goods",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static SalesPartnersOrGoods(data, partner) {
        var result = null;
        if (partner) {
            $.ajax({
                // url: Comm.ServerUrl + "invoices/partners_sold",
                url: Comm.ApiURL() + "invoices/partners_sold",
                method: "GET",
                cache: false,
                data: data,
                async: false,
            })
                .done(function (res) {
                    var json = JSON.parse(res);
                    if (json.code != "0") {
                        Context.LastErrorCode = json.code;
                        Context.ErrJson = json;
                    } else {
                        result = json;
                    }
                })
                .fail(function (jqXHR, textStatus) {
                    console.log(jqXHR.statusText);
                    Comm.ProcessResponse(3);
                });
        } else {
            $.ajax({
                // url: Comm.ServerUrl + "invoices/goods_sold",
                url: Comm.ApiURL() + "invoices/goods_sold",
                method: "GET",
                cache: false,
                data: data,
                async: false,
            })
                .done(function (res) {
                    var json = JSON.parse(res);
                    if (json.code != "0") {
                        Context.LastErrorCode = json.code;
                        Context.ErrJson = json;
                    } else {
                        result = json;
                    }
                })
                .fail(function (jqXHR, textStatus) {
                    console.log(jqXHR.statusText);
                    Comm.ProcessResponse(3);
                });
        }
        return result;
    }

    static SaveDelivery(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "invoices/save_delivery",
            url: Comm.ApiURL() + "invoices/save_delivery",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.id;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static OnTheWay(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "invoices/deliveries_on_the_road",
            url: Comm.ApiURL() + "invoices/deliveries_on_the_road",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);

                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static SetArrived(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "invoices/the_goods_arrived",
            url: Comm.ApiURL() + "invoices/the_goods_arrived",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.id;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static GetOnWayDetails(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "invoices/the_goods_arrived",
            url: Comm.ApiURL() + "invoices/delivery_positions",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.positions;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static PackingList(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "report/packing_list",
            url: Comm.ApiURL() + "report/packing_list",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static SalesByPartnersAndGoods(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "report/sales_by_partners_and_goods",
            url: Comm.ApiURL() + "report/sales_by_partners_and_goods",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.html;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static PackingListsByPartners(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "invoices/packing_lists_by_partners",
            url: Comm.ApiURL() + "invoices/packing_lists_by_partners",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static PackingListsByGoods(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "invoices/packing_lists_by_goods",
            url: Comm.ApiURL() + "invoices/packing_lists_by_goods",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static SalesByPartners(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "report/sales_by_partners",
            url: Comm.ApiURL() + "report/sales_by_partners",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.html;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static SalesByGoods(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "report/sales_by_goods",
            url: Comm.ApiURL() + "report/sales_by_goods",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.html;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static DeliveriesByPartnersAndGoods(data, deliveryReportType) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "report/deliveries_by_partners_and_goods",
            url:
                Comm.ApiURL() +
                "report/deliveries_by_partners_and_goods" +
                (deliveryReportType === "0" ? "_arrived" : ""),
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.html;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static DeliveriesByPartners(data, deliveryReportType) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "report/deliveries_by_partners",
            url:
                Comm.ApiURL() +
                "report/deliveries_by_partners" +
                (deliveryReportType === "0" ? "_arrived" : ""),
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.html;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static DeliveriesByGoods(data, deliveryReportType) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "report/deliveries_by_goods",
            url:
                Comm.ApiURL() + "report/deliveries_by_goods" + (deliveryReportType === "0" ? "_arrived" : ""),
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json.html;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static ReportQty(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "report/qty",
            url: Comm.ApiURL() + "report/qty",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.hasOwnProperty("code") && json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static ReportScalesSorting(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "report/scales_sorting",
            url: Comm.ApiURL() + "report/scales_sorting",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.hasOwnProperty("code") && json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static ReportOriginalSorting(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "report/original_sorting",
            url: Comm.ApiURL() + "report/original_sorting",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.hasOwnProperty("code") && json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static ReportScalesSortingByOperator(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "report/scales_sorting_by_operator",
            url: Comm.ApiURL() + "report/scales_sorting_by_operator",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.hasOwnProperty("code") && json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static GetPackingListData(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "invoices/packing_list_data",
            url: Comm.ApiURL() + "invoices/packing_list_data",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.hasOwnProperty("code") && json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static SetPackingListData(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "invoices/update_packing_list",
            url: Comm.ApiURL() + "invoices/update_packing_list",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.hasOwnProperty("code") && json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static Corrections(data) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + "report/qty_corrections",
            url: Comm.ApiURL() + "report/qty_corrections",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.hasOwnProperty("code") && json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                } else {
                    result = json;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static CallServerFunction(funcName, data) {
        var result = null;
        $.ajax({
            // url: Comm.ServerUrl + funcName,
            url: Comm.ApiURL() + funcName,
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.hasOwnProperty("code") && json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                    console.log("error", json);
                } else {
                    result = json;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static ConditionsOfDelivery(data) {
        return Comm.CallServerFunction("invoices/conditions_of_delivery", data);
    }

    static PaymentConditions(data) {
        return Comm.CallServerFunction("invoices/payment_conditions", data);
    }

    static PlacesOfShipment(data) {
        return Comm.CallServerFunction("invoices/places_of_shipment", data);
    }

    static InvoiceData(data) {
        return Comm.CallServerFunction("invoices/get_invoice", data);
    }

    static SaveInvoice(data) {
        return Comm.CallServerFunction("invoices/save_invoice", data);
    }

    static SortingInArticles(data) {
        return Comm.CallServerFunction("article/sorting_in_articles", data);
    }

    static AllDeliveries(data) {
        return Comm.CallServerFunction("invoices/all_deliveries", data);
    }

    static DeleteDelivery(data) {
        return Comm.CallServerFunction("invoices/delete_delivery", data);
    }

    static GetShopPartners(data) {
        return Comm.CallServerFunction("shop/get_partners", data);
    }

    static GetShopShops(data) {
        return Comm.CallServerFunction("shop/get_shops", data);
    }

    static AddShopPartner(data) {
        return Comm.CallServerFunction("shop/add_shop", data);
    }

    static DeleteShopShop(data) {
        return Comm.CallServerFunction("shop/delete_shop", data);
    }

    static SavePayment(data, okFunc, notOkFunc) {
        var result = null;

        $.ajax({
            // url: Comm.ServerUrl + funcName,
            url: Comm.ApiURL() + "pay/pay",
            method: "POST",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                if (json.hasOwnProperty("code") && json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                    notOkFunc(json);
                } else {
                    result = json;
                    okFunc(Translation.Trans("ok"));
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }

    static ValidSession() {
        var now = moment(new Date());
        var end = Comm.LastSessionCheck;
        if (end != null) {
            var duration = moment.duration(now.diff(end));
            var minutes = duration.asMinutes();
            if (minutes <= 10) return true;
        }

        var context = Context.GetContext();
        if (!context) return false;

        var data = {
            session: context.Sid,
        };

        var result = false;

        $.ajax({
            // url: Comm.ServerUrl + "admin/sessionuser",
            url: Comm.ApiURL() + "admin/sessionuser",
            method: "GET",
            cache: false,
            data: data,
            async: false,
        })
            .done(function (res) {
                var json = JSON.parse(res);
                console.log("checkjson", json);
                result = json.code == 0;
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        if (result) Comm.LastSessionCheck = moment();
        return result;
    }

    static CallGetServerFunction(funcName, data) {
        var result = null;
        var str = Object.keys(data)
            .map(function (key) {
                return key + "=" + data[key];
            })
            .join("&");
        $.ajax({
            // url: Comm.ServerUrl + funcName,
            url: Comm.ApiURL() + funcName + "?" + str,
            method: "GET",
            cache: false,
            async: false,
        })
            .done(function (res) {
                console.log("res", res);
                var json = JSON.parse(res);
                if (json.hasOwnProperty("code") && json.code != "0") {
                    Context.LastErrorCode = json.code;
                    Context.ErrJson = json;
                    console.log("error", json);
                } else {
                    result = json;
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR.statusText);
                Comm.ProcessResponse(3);
            });

        return result;
    }
}

export default Comm;



// WEBPACK FOOTER //
// ./src/comm/comm.js